import type { PayRateInput, PaySummary } from '../../types/pay'
import { request } from './http'

export const getMyPay = () => request<PaySummary>('/profile/pay')

export const getMemberPay = (userId: string) => request<PaySummary>(`/admin/pay-rates/${userId}`)

export const savePayRate = (userId: string, body: PayRateInput) =>
	request<PaySummary>(`/admin/pay-rates/${userId}`, { method: 'PUT', body: JSON.stringify(body) })

export const deletePayRate = (userId: string, id: number) => request<PaySummary>(`/admin/pay-rates/${userId}/${id}`, { method: 'DELETE' })
